import AntdTable from "src/components/AntdTable/Table"
import AntdMobileTable from "src/components/AntdMobileTable/AntdMobileTable"
import { useDispatch, useSelector } from "react-redux"
import { useState, useEffect } from "react"
import { getRacesParticipants } from "src/store/Slices/UsersRatingSlice"

const RacesParticipants = ({ raceId }) => {
  const dispatch = useDispatch()
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(20)
  const racesParticipantsInfo = useSelector(
    (state) => state.UsersRatingSlice?.racesParticipantsInfo,
  )
  const loading = useSelector((state) => state.UsersRatingSlice?.isLoading)
  const columns = racesParticipantsInfo?.data?.value?.columns.map((element) => {
    return {
      ...element,
    }
  })

  const rows = racesParticipantsInfo?.data?.value?.rows.map((element) => {
    return {
      key: element?.key,
      id: element?.id,
      raceId: element?.raceId,
      userId: element?.userId,
      phoneNumber: element?.phoneNumber,
      clientF: element?.clientF,
      clientI: element?.clientI,
      clientO: element?.clientO,
      fio: element?.fio,
      resultPoints: element?.resultPoints,
    }
  })

  useEffect(() => {
    dispatch(getRacesParticipants(raceId))
  }, [raceId])

  return (
    <>
      {window.innerWidth >= 768 ? (
        <AntdTable
          columns={columns}
          rows={rows}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={pageSize}
          loading={loading}
          total={racesParticipantsInfo?.data?.value?.totalCount || 0}
        />
      ) : (
        <AntdMobileTable
          columns={columns}
          rows={rows}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={pageSize}
          loading={loading}
          total={racesParticipantsInfo?.data?.value?.totalCount || 0}
        />
      )}
    </>
  )
}

export default RacesParticipants
